import { styled } from '@linaria/react';
import { fonts, layout, primitives, semantic, shadow, size, space } from '../../theme/tokens';
import { EntityImage } from '../../components/EntityImage';

export const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: ${space['space-300']} 0 ${space['space-600']};
`;

export const CloseButton = styled.button`
  position: absolute;
  top: ${space['space-400']};
  right: ${space['space-300']};
  width: 44px;
  height: 32px;
  border-radius: ${size.radius['radius-full']};
  background: ${semantic.bg.canvas};
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${semantic.text.primary};
  z-index: 1;
  box-shadow: ${shadow.sm};
`;

export const Image = styled(EntityImage)`
  display: block;
  width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: ${size.radius['radius-md']};

  @media (max-width: ${layout.desktopBreakpoint}) {
    height: 170px;
  }
`;

export const ImagePlaceholder = styled.div`
  width: 100%;
  height: 200px;
  background: ${semantic.bg.surfaceSubtle};
  border-radius: ${size.radius['radius-md']};

  @media (max-width: ${layout.desktopBreakpoint}) {
    height: 170px;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${space['space-300']};
  padding: ${space['space-800']} 0 ${space['space-600']};
  text-align: center;
`;

export const Heading = styled.h2`
  margin: 0;
  font-family: ${fonts.body};
  font-size: ${fonts.size['2xl']};
  font-weight: ${fonts.weight.normal};
  color: ${semantic.text.primary};
  line-height: ${primitives.typography.lineHeight.tight};
`;

export const ValidFor = styled.p`
  margin: 0;
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  font-weight: ${fonts.weight.semiBold};
  color: ${semantic.text.primary};
`;

export const Body = styled.div`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  color: ${semantic.text.secondary};
  line-height: ${primitives.typography.lineHeight.relaxed};

  & p {
    margin: 0 0 ${space['space-200']};
    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const CtaContainer = styled.div`
  margin-top: ${space['space-200']};
`;
